// extracted by mini-css-extract-plugin
export var statItem = "_js-1";
export var statsRow = "_js-0";